var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiece1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.635,
    height: 121.127,
    viewBox: "0 0 185.635 121.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mol\\xE9cule_3D",
    "data-name": "mol\\xE9cule 3D",
    transform: "translate(-776.506 93.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M130.08,315.618s22.232-17.9,49.229-4.883",
    transform: "translate(781.963 -366.15)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M135.264,310.208c-2.728-3.807-5.187-7.413-8.388-10.081a175.488,175.488,0,0,0-21.182-14.511c-10.745-6.528-22.386-10.9-34.984-11.115-23.467-.38-42.5,10.683-59.624,25.794a53.5,53.5,0,0,0-9.479,11.6c-5.8,9.9-.8,19.783,10.478,20.6a25.424,25.424,0,0,0,11.25-1.561c11-4.587,21.9-8.816,32.769-13.709,3.777-1.708,7.668-3.174,12.917-5.326-3.695,9.375-3.152,11.011,3.611,15.271a27.73,27.73,0,0,0,4.79,2.719c13.535,4.777,28.607,6.665,42.574,3.934,5.393-1.149,10.788-3.573,14.545-7.7,5.218-5.631,1.682-14.166.745-15.906",
    transform: "translate(777.334 -367.877)",
    fill: "#fcb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M123.947,335.655c-16.1-3.979-33.169-3.474-48.577,3.439-8.486,3.81-10.355,7.112-7.961,16.78-2.57-.644-2.959-.449-4.938-1.378-3.886-1.815-7.46-4.359-11.408-6-10.673-4.412-21.273-9.225-32.3-12.5C9.553,333.26.269,338.589.01,346.685c-.166,5.045,2.373,11.156,5.637,15.167A83.741,83.741,0,0,0,60.73,392.566c28.63,3.736,51.384-11.2,71.1-30.112,9.958-9.552,5.481-23.484-7.885-26.788",
    transform: "translate(776.503 -365.401)",
    fill: "#fcb813"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiece1);
export default __webpack_public_path__ + "static/media/piece-1.037b749b1c23a2910344e6f71b276d23.svg";
export { ForwardRef as ReactComponent };